import React, { PropsWithChildren } from "react";

import MuiToggleButtonGroup from "@mui/material/ToggleButtonGroup";

import { AtomProps } from "@/uiKit/atoms/utils/AtomTypes.ts";

export type BaseToggleButtonGroupProps = PropsWithChildren<{}>;

export type ToggleButtonGroupProps = AtomProps<BaseToggleButtonGroupProps>;

export const ToggleButtonGroup: React.FC<ToggleButtonGroupProps> = ({ children, ...props }) => {
  return <MuiToggleButtonGroup {...props}>{children}</MuiToggleButtonGroup>;
};
